import { Switch, Route, BrowserRouter as Router } from "react-router-dom";

import React from "react";
import { HomePage } from "@pages/HomePage";
import ClientAccessRoute from "./clientAccess";
import { Layout } from "@components/layout";
import { useQuery } from "react-query";
import { getTenantImage, getTenantLogoInfo } from "@services/tenant";

const MainRouter = () => {
  const { data: tenantInfo } = useQuery({
    queryKey: ["getTenantLogoInfo"],
    queryFn: getTenantLogoInfo,
  });

  useQuery({
    queryKey: ["getTenantImage", tenantInfo?.logoURL],
    queryFn: () => getTenantImage(tenantInfo?.logoURL),
    enabled: !!tenantInfo?.logoURL,
  });

  return (
    <Router basename="/#/customer-access">
      <Switch>
        <Route exact path="/">
          <HomePage />
        </Route>
        <Route path="*">
          <Layout>
            <ClientAccessRoute />
          </Layout>
        </Route>
      </Switch>
    </Router>
  );
};

export default MainRouter;
